// MultiPartnerForm.js
import React, { useState } from "react";
import { Step } from "semantic-ui-react";
import { initialValues } from "./PartnerForm.form";
import { initialValuesTwo } from "./PartnerFormTwo.form";
import { initialValuesThree } from "./PartnerFormThree.form";
import { PartnerFormOne } from "./PartnerFormOne";
import { PartnerFormTwo } from "./PartnerFormTwo";
import { PartnerFormThree } from "./PartnerFormThree";
import { useTranslation } from "react-i18next";
import "./MultiPartnerForm.scss";

export function MultiPartnerForm(props) {
  const { user, onReload, onClose } = props;
  const { t } = useTranslation("partners");

  // Aquí podrías controlar la bandera:
  // Si por alguna razón quieres a veces enviarlo y a veces no, podrías hacerlo dinámico.
  const envioDatacontact = false; // O true si quieres enviarlo

  const mergedInitialValues = {
    ...initialValues(user),
    ...initialValuesTwo(user),
    ...initialValuesThree(user),
  };

  const [formData, setFormData] = useState(mergedInitialValues);
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prevStep) => prevStep + 1);
  const prevStep = () => setStep((prevStep) => prevStep - 1);

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  return (
    <div>
      <div className="step-group-container">
        <Step.Group ordered>
          <Step active={step === 1} completed={step > 1}>
            <Step.Content>
              <Step.Title>{t("form.step1Title")}</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 2} completed={step > 2}>
            <Step.Content>
              <Step.Title>{t("form.step2Title")}</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 3} completed={step > 3}>
            <Step.Content>
              <Step.Title>{t("form.step3Title")}</Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>
      </div>

      {step === 1 && (
        <PartnerFormOne
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          user={user}
          onReload={onReload}
          onClose={onClose}
        />
      )}
      {step === 2 && (
        <PartnerFormTwo
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          user={user}
          onReload={onReload}
          onClose={onClose}
        />
      )}
      {step === 3 && (
        <PartnerFormThree
          formData={formData}
          updateFormData={updateFormData}
          prevStep={prevStep}
          user={user}
          onReload={onReload}
          onClose={onClose}
          envioDatacontact={envioDatacontact} // <-- Pasamos la bandera a Form3
        />
      )}
    </div>
  );
}
